import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthenticationService, User } from '@damofire/data-security';
import { AutoUnsubscribe } from '../auto-unsubscribe.decorator';
import { Subscription } from 'rxjs';

@AutoUnsubscribe()
@Directive({ selector: '[appIfMyself]', standalone: true })
export class IfMyselfDirective implements OnInit {
  private user: string;
  private currentUser: User;
  private userSub: Subscription;

  constructor(
    private readonly authenticationService: AuthenticationService,
    private readonly templateRef: TemplateRef<any>,
    private readonly viewContainer: ViewContainerRef,
  ) {}

  ngOnInit(): void {
    this.userSub = this.authenticationService.subscribe({
      next: (user) => {
        this.currentUser = user;
        this.revalidate();
      },
    });
  }

  @Input()
  set appIfMyself(user: string) {
    this.user = user;
    this.revalidate();
  }

  private revalidate(): void {
    this.viewContainer.clear();
    console.log(`Evaluating current user to filter component. [${this.currentUser?._id} vs ${this.user}]`);

    if (this.currentUser && this.currentUser._id !== this.user) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
